import { useState } from 'react';
import woman from '../../common/assets/woman.png';
import chorwatRazgoto from '../../common/assets/ChorwatRazgoto3.png'

export default function ProgressiveMainHero({ lowSrc, highSrc, alt }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className='home-page__circle'>
      <img className='home-page__circle-image' src={chorwatRazgoto} alt='hero' />
    </div>
  );
}
